var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lgpr"}},[(false)?_c('Create',{attrs:{"lgpr":_vm.lgpr},on:{"update:lgpr":function($event){_vm.lgpr=$event}}}):_vm._e(),_c('Status',{attrs:{"lgpr":_vm.lgpr}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }